import {Component,OnInit} from "@angular/core";
import {VoyagesReferentielsCompagniesItemComponent} from "@components/admin/voyages/referentiels/compagnies/voyages-referentiels-compagnies-item/voyages-referentiels-compagnies-item.component";
import {CompagniesDTO} from "@domain/admin/voyages/referentiels/compagniesDto";
import {ListView,TypeComparaison} from "@domain/common/list-view";
import {Sorting} from "@domain/common/list-view/sorting";
import {TranslateService} from "@ngx-translate/core";

/**
 * Composant d'affichage de la liste des compagnies
 */
@Component({
    host: {'data-test-id': 'voyages-referentiels-compagnies'},
    selector: 'voyages-referentiels-compagnies',
    templateUrl: './voyages-referentiels-compagnies.component.html'
})
export class VoyagesReferentielsCompagniesComponent implements OnInit {
    /** Liste des compagnies, pour utiliser le composant ListViewComponent */
    listeCompagnies: ListView<CompagniesDTO, VoyagesReferentielsCompagniesItemComponent>;

    /**
     * Constructeur
     *
     * @param translateService Service de traduction
     */
    constructor(
        private translateService: TranslateService) {
    }

    /**
     * Initialisation du composant
     */
    ngOnInit() {
        //Création de la liste des compagnies
        this.listeCompagnies = new ListView<CompagniesDTO, VoyagesReferentielsCompagniesItemComponent>({
            uri: `/controller/TravelHubReferentiel/listeAllCompagnie`,
            title: this.translateService.instant('admin.voyages.referentiels.onglets.compagnies'),
            component: VoyagesReferentielsCompagniesItemComponent,
            isFilter: true,
            defaultOrder: 'libelle',
            listeFilters: [
                {
                    clef: 'libelle',
                    title: this.translateService.instant('admin.voyages.referentiels.libelle'),
                    isDefault: true,
                    typeComparaison: TypeComparaison[TypeComparaison.LIKE]
                },{
                    clef: 'typePrestation',
                    title: this.translateService.instant('admin.voyages.referentiels.prestation'),
                    isDefault: true,
                    typeComparaison: TypeComparaison[TypeComparaison.LIKE],
                    listeValues: [{
                        code: "0",
                        libelle: this.translateService.instant('admin.voyages.referentiels.typePrestation.avion')
                    },{
                        code: "1",
                        libelle: this.translateService.instant('admin.voyages.referentiels.typePrestation.train')
                    },{
                        code: "2",
                        libelle: this.translateService.instant('admin.voyages.referentiels.typePrestation.hotel')
                    },{
                        code: "3",
                        libelle: this.translateService.instant('admin.voyages.referentiels.typePrestation.voitureLocation')
                    },{
                        code: "4",
                        libelle: this.translateService.instant('admin.voyages.referentiels.typePrestation.voitureSociete')
                    },{
                        code: "5",
                        libelle: this.translateService.instant('admin.voyages.referentiels.typePrestation.voiturePersonnelle')
                    },{
                        code: "6",
                        libelle: this.translateService.instant('admin.voyages.referentiels.typePrestation.document')
                    },{
                        code: "7",
                        libelle: this.translateService.instant('admin.voyages.referentiels.typePrestation.avionTrain')
                    },{
                        code: "8",
                        libelle: this.translateService.instant('admin.voyages.referentiels.typePrestation.avance')
                    },{
                        code: "9",
                        libelle: this.translateService.instant('admin.voyages.referentiels.typePrestation.transport1')
                    },{
                        code: "10",
                        libelle: this.translateService.instant('admin.voyages.referentiels.typePrestation.transport2')
                    },{
                        code: "11",
                        libelle: this.translateService.instant('admin.voyages.referentiels.typePrestation.transport3')
                    },{
                        code: "12",
                        libelle: this.translateService.instant('admin.voyages.referentiels.typePrestation.service1')
                    },{
                        code: "13",
                        libelle: this.translateService.instant('admin.voyages.referentiels.typePrestation.service2')
                    },{
                        code: "14",
                        libelle: this.translateService.instant('admin.voyages.referentiels.typePrestation.service3')
                    }]
                },{
                    clef: 'code',
                    title: this.translateService.instant('admin.voyages.referentiels.code'),
                    isDefault: true,
                    typeComparaison: TypeComparaison[TypeComparaison.LIKE]
                },{
                    clef: 'isCustom',
                    title: this.translateService.instant('admin.voyages.referentiels.personnalise'),
                    isDefault: false,
                    typeComparaison: TypeComparaison[TypeComparaison.EQUAL],
                    listeValues: [{
                        code: "0",
                        libelle: this.translateService.instant('confirmation.non')
                    },{
                        code: "1",
                        libelle: this.translateService.instant('confirmation.oui')
                    }]
                },
            ]
        });

        //Définition des colonnes de tri
        this.listeCompagnies.columns = [
            { key: 'libelle', title: 'admin.voyages.referentiels.libelle' },
            { key: 'prestation', title: 'admin.voyages.referentiels.prestation' },
            { key: 'code', title: 'admin.voyages.referentiels.code' },
            { key: 'custom', title: 'admin.voyages.referentiels.personnalise' },
        ];

        //Ajout du tri de la liste selon l'ordre voulu
        this.listeCompagnies.sorting = new Sorting(this.listeCompagnies.columns, "libelle");

        //Persistence des filtres
        this.listeCompagnies.isPersistFilters = true;

        //Nom de la classe
        this.listeCompagnies.className = 'VoyagesReferentielsCompagniesComponent';
    }
}
